import { useSelector } from "react-redux";

/**
 * Returns the current user's role from Redux store.
 * @returns {string|null} User role ('user' | 'admin' | 'super_admin'), or null when not set.
 */
const useRole = () => {
  const reduxRole = useSelector((state) => state.user?.role);
  let storedRole = null;
  try {
    const raw = localStorage.getItem("user") || localStorage.getItem("user_info");
    storedRole = raw ? JSON.parse(raw)?.role : null;
  } catch {
    storedRole = null;
  }
  const role = reduxRole || storedRole || null;
  return role ? String(role).toLowerCase() : null;
};

export default useRole;
